type NotObject<T> = T extends object ? never : T;

export function areSimpleArraysEqual<T>(arr1: NotObject<T>[], arr2: NotObject<T>[]): boolean {
  if (arr1.length !== arr2.length) return false;

  const sortedArr1 = arr1.slice().sort();
  const sortedArr2 = arr2.slice().sort();

  for (let i = 0; i < sortedArr1.length; i++) {
    if (sortedArr1[i] !== sortedArr2[i]) return false;
  }
  return true;
}

export function areObjectArraysEqual<T extends { id: number }>({
  arr1,
  arr2,
  keysToCheck,
}: {
  arr1: T[];
  arr2: T[];
  keysToCheck?: (keyof T)[];
}): boolean {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const sortedArr1 = arr1.slice().sort((a, b) => a.id - b.id);
  const sortedArr2 = arr2.slice().sort((a, b) => a.id - b.id);

  const keysToCompare = keysToCheck ?? (Object.keys(sortedArr1[0] || {}) as (keyof T)[]);

  return sortedArr1.every((item, index) =>
    keysToCompare.every((key) => item[key] === sortedArr2[index]?.[key]),
  );
}
